import { Button } from "primereact/button";
import { InputMask } from "primereact/inputmask";
import { InputTextarea } from "primereact/inputtextarea";
import { SelectButton } from "primereact/selectbutton";
import { useState } from "react";
import ModalSeplag from "../../../../../../components/ModalSeplag";
import RotuloSeplag from "../../../../../../components/RotuloSeplag";
import { adicionarAnaliseGeralAcao, updatedAnaliseGeralAcao } from "../../../../../../service/Rag/lançamento/acao";

const ModalAnaliseGeralAcaoSeplag = ({
  visibleModal,
  setVisibleModal,
  setActionModal,
  actionModal,
  setAtualizarData,
  dataRow,
  dadosItemAcao,
}) => {
  const [data, setData] = useState({
    dataAnaliseAcao: dataRow.dataAnaliseAcao !== undefined ? dataRow.dataAnaliseAcao : "",
    descAnaliseAcao: dataRow.descAnaliseAcao !== undefined ? dataRow.descAnaliseAcao : "",
    maximoCaracteres: 4000,
    flagAcatadoSetorial: dataRow.flagAcatadoSetorial !== undefined ? dataRow.flagAcatadoSetorial : "",
  });
  const paymentOptions = [
    { name: "Acatado pela Setorial", code: "S" },

    { name: "Não acatado pela Setorial", code: "N" },
  ];
  const salvarAnaliseGeral = async () => {
    let now = new Date();
    let date = now.getDate() + "/" + (now.getMonth() + 1) + "/" + now.getFullYear();
    let formAnaliseAcao = {
      ...dataRow,
      ptaMonitora: {
        idenPtaMonitora: dadosItemAcao.idenPtaMonitora,
      },
      dataInclusao: date,
    };

    formAnaliseAcao.dataAnaliseAcao = data.dataAnaliseAcao;
    formAnaliseAcao.descAnaliseAcao = data.descAnaliseAcao;
    formAnaliseAcao.flagAcatadoSetorial = data.flagAcatadoSetorial;
    formAnaliseAcao.statAnaliseAcao = 1;
    formAnaliseAcao.tipoAnaliseAcao = 1;

    await adicionarAnaliseGeralAcao(formAnaliseAcao).then((_res) => {
      window.$toast.current.show({
        severity: "success",
        summary: "Ação Efetuada",
        detail: "Criado com Sucesso",
        life: 5000,
      });
      setAtualizarData(true);
      setVisibleModal(false);
    });
  };
  const alterarAnaliseGeral = async () => {
    let formAnaliseAcao = { ...dataRow };
    formAnaliseAcao.idenAnaliseAcao = dataRow.idenAnaliseAcao;

    formAnaliseAcao.dataAnaliseAcao = data.dataAnaliseAcao;
    formAnaliseAcao.descAnaliseAcao = data.descAnaliseAcao;
    formAnaliseAcao.flagAcatadoSetorial = data.flagAcatadoSetorial;

    await updatedAnaliseGeralAcao({
      idenAnaliseAcao: dataRow.idenAnaliseAcao,
      postBody: formAnaliseAcao,
    }).then((_res) => {
      window.$toast.current.show({
        severity: "success",
        summary: "Ação Efetuada",
        detail: "Alterado com Sucesso",
        life: 5000,
      });
      setAtualizarData(true);
      setVisibleModal(false);
    });
  };
  return (
    <ModalSeplag
      titulo="Análise Geral da Ação pela equipe Central da SEPLAG"
      tamanho="960px"
      type="NONE"
      visible={visibleModal}
      fechar={() => {
        setVisibleModal(false);
        setActionModal({
          edit: false,
          disbled: false,
          create: false,
        });
      }}
    >
      <div className="field" style={{ width: "10rem" }}>
        <RotuloSeplag nome="Data">
          <InputMask
            disabled={actionModal.disabled}
            value={data.dataAnaliseAcao}
            mask="99/99/9999"
            placeholder="__/__/____"
            onChange={(e) => {
              setData((prevState) => ({
                ...prevState,
                dataAnaliseAcao: e.value,
              }));
            }}
          ></InputMask>
        </RotuloSeplag>
      </div>
      <div className="field">
        <RotuloSeplag nome="Análise" cols="3">
          <InputTextarea
            value={data.descAnaliseAcao}
            autoResize
            maxLength={data.maximoCaracteres}
            disabled={actionModal.disabled}
            onChange={(e) => {
              setData((prevState) => ({
                ...prevState,
                descAnaliseAcao: e.target.value,
              }));
            }}
          />
          <span>
            {data.descAnaliseAcao === ""
              ? `${data.maximoCaracteres} caracteres Restante`
              : ` ${data.maximoCaracteres - data.descAnaliseAcao.length} caracteres restantes `}
          </span>
        </RotuloSeplag>
      </div>
      <div className="field ">
        <RotuloSeplag nome="Situação" cols="3">
          <SelectButton
            value={data.flagAcatadoSetorial}
            disabled={actionModal.disabled}
            options={paymentOptions}
            onChange={(e) => {
              setData((prevState) => ({ ...prevState, flagAcatadoSetorial: e.value }));
            }}
            optionLabel="name"
            optionValue="code"
          />
        </RotuloSeplag>
      </div>
      <div className="grid" style={{ margin: "1rem" }}>
        {actionModal.edit === true && (
          <div className="col">
            <Button label="Alterar" onClick={alterarAnaliseGeral} />
          </div>
        )}

        {actionModal.create === true && (
          <div className="col">
            <Button label="Adicionar" onClick={salvarAnaliseGeral} />
          </div>
        )}

        <div className="col">
          <Button
            label={actionModal.disabled === true ? "Fechar" : "Cancelar"}
            className="p-button-secondary"
            onClick={() => {
              setVisibleModal(false);
              setActionModal({
                edit: false,
                disbled: false,
                create: false,
              });
            }}
          />
        </div>
      </div>
    </ModalSeplag>
  );
};
export default ModalAnaliseGeralAcaoSeplag;
